export default __webpack_public_path__ + "static/media/poison_egg_3.b3f4d703.mp4";